import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import type { RevenueTrendPoint } from '@/src/types/admin/analytics'

interface RevenueLineChartProps {
  data: RevenueTrendPoint[]
  height?: number
  showLegend?: boolean
}

function formatMonth(month: string): string {
  const [year, m] = month.split('-')
  const date = new Date(parseInt(year), parseInt(m) - 1, 1)
  return date.toLocaleDateString('th-TH', { month: 'short', year: '2-digit' })
}

function formatThb(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)}K`
  return value.toLocaleString()
}

export function RevenueLineChart({
  data,
  height = 300,
  showLegend = false,
}: RevenueLineChartProps) {
  const chartData = data.map((d) => ({
    month: formatMonth(d.month),
    รายได้: d.revenue,
  }))

  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={chartData} margin={{ top: 5, right: 10, left: 10, bottom: 5 }}>
        <defs>
          <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#6366f1" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#6366f1" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
        <XAxis
          dataKey="month"
          tick={{ fontSize: 12 }}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          tickFormatter={formatThb}
          tick={{ fontSize: 12 }}
          tickLine={false}
          axisLine={false}
          width={48}
        />
        <Tooltip
          formatter={(value: number) => [`฿${value.toLocaleString()}`, 'รายได้']}
          labelStyle={{ fontWeight: 600 }}
        />
        {showLegend && <Legend />}
        <Area
          type="monotone"
          dataKey="รายได้"
          stroke="#6366f1"
          strokeWidth={2}
          fill="url(#colorRevenue)"
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}
